var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAldia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-2.074 -8.851 66.202 71.795",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    transform: "matrix(1, 0, 0, 1, 3.033879, -2.814096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M380.27,268.345a48.9,48.9,0,0,0-48.627,44.486,152.908,152.908,0,0,1,15.885-18.308,1.252,1.252,0,1,1,1.79,1.751c-.976.992-1.964,2.021-2.96,3.064q-.854.893-1.67,1.767c-.1.107-.2.216-.3.323-8,8.563-13.712,16.017-17.863,25.272a1.253,1.253,0,0,0,.627,1.655,1.259,1.259,0,0,0,1.66-.629,68.4,68.4,0,0,1,5.122-9.321A48.818,48.818,0,0,0,375.7,292.737a1.251,1.251,0,0,0-1.1-1.846h-4.64l8.32-4.754a1.258,1.258,0,0,0,.563-.679,48.676,48.676,0,0,0,2.685-15.858,1.255,1.255,0,0,0-1.253-1.255",
    transform: "translate(-326.414 -268.345)",
    style: {
      fill: "rgb(52, 52, 127)"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAldia);
export default __webpack_public_path__ + "static/media/aldia.d322c69b86edfebddc1ff4964ebc4d62.svg";
export { ForwardRef as ReactComponent };